module.exports = __webpack_public_path__ + "static/media/logo8.54053a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientLogos/clientLogos/logo8.png
// module id = 422
// module chunks = 0